module.exports = __webpack_public_path__ + "static/media/s_sf_16.62b27bd4.png";